<template>
  <Command
    v-if="mediaPlayer?.state === MediaPlayerState.Playing"
    @click="mediaPlayer?.pause()"
  >
    <slot
      v-bind="{
        disabled: !mediaPlayer,
        icon: 'pause',
        label: t('tts.controls.pause'),
        toolTip: t('tts.controls.pause'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { inject, Ref } from "vue";
import { useI18n } from "vue-i18n";

import Command from "../command";
import MediaPlayer, { MediaPlayerState } from "@/services/media/player";

const { t } = useI18n();

const mediaPlayer = inject("mediaPlayer") as Ref<MediaPlayer | null>;
</script>
